import cuid from "cuid";
import { ValidationRules } from "@/models/Validation";
import PartBank from "@/modules/cashPoint/models/PartBank";
import PaymentModeDisplay from "@/modules/paymentMode/models/PaymentModeDisplay";
import { formatDateISO, newDate } from "@/utils/formatDates";
import User from "@/modules/invoiceGroup/models/User";
import { t } from "@/plugins/i18n";

const today = new Date();
today.setHours(0);
today.setMinutes(0);
today.setSeconds(0);

export enum PaymentScheduleOption {
  Custom = "Egyedi",
  Monthly = "Havi",
  Quarterly = "Negyedéves",
}

export class PaymentSchedule {
  id = 0;
  invoiceNo = 1;
  currency = "HUF";
  responsibleUserID = 1;
  items: PaymentScheduleItem[] = [];
  paymentScheduleType = 1;
  selectedResponsibleUser: User | undefined = undefined;

  constructor(params?: Partial<PaymentSchedule>) {
    const data = { ...params };
    Object.assign(this, data);
  }
}

export class PaymentScheduleItem {
  id = 0;
  cuid = cuid();
  amount = 0;
  deadline = newDate(today);
  bankAccount = 1;
  paymentMode = 1;
  details = false;

  deadlineDisplay = formatDateISO(today);
  selectedPaymentMode: PaymentModeDisplay | undefined = undefined;
  selectedBankAccount: PartBank | undefined = undefined;
  accountNoSplit = "";

  constructor(params?: Partial<PaymentScheduleItem>) {
    const data = { ...params };
    Object.assign(this, data);
  }
}

// validation
export const rules: ValidationRules = {
  date: [(v: string) => !!v || t("HibasDatum")],
  amount: [(v: number) => !!v || t("KotelezoMegadni"), (v: number) => v > 0 || t("InvoicePaymentSchedule_AzOsszegNemLehetNullaVagy")],
  deadline: [(v: string) => !!v || t("HibasDatum"), (v: string) => new Date(v) > today || t("InvoicePaymentSchedule_MultbeliFizetesiHatarido")],
  bankAccount: [(v: PartBank) => !!v || t("InvoicePaymentSchedule_HibasSzamlaMegadas")],
  paymentMode: [(v: PaymentModeDisplay) => !!v || t("InvoicePaymentSchedule_FizetesiModMegadasaKotelezo")],
};
